<div class="wo-order-state" [ngClass]="getCssClass(state)" [class.wo-order-state--small]="small">
  {{ state | orderState }}
  <ng-container *ngIf="extra">
    <span class="wo-order-state__divider"></span>
    <span class="wo-order-state__extra" >{{ extra }}</span>
  </ng-container>
</div>
